"use client";
import type { getProductSizes } from "@frend-digital/centra-legacy/src/formatting/atomics/baseAtomics";
import isEqual from "lodash.isequal";
import { createContext, use, useState } from "react";

export type ProductSizes = ReturnType<typeof getProductSizes>;

export type ProductSize = {
  fewLeft: boolean;
  name: string;
  label: string;
  stock: boolean;
  itemId: string;
  sku?: string;
  ean?: string;
};
const useSizes = (sizes?: ProductSize[]) => {
  const ctx = useSizeContext();

  const internal = useState<ProductSize | null>(null);

  const [selected, setSelected] = ctx
    ? ([ctx.selectedSize, ctx.setSelectedSize] as const)
    : internal;

  const formattedSizes = sizes?.map((size: ProductSize) => {
    return {
      ...size,
      isSelected: isEqual(selected?.itemId, size?.itemId),
      selectSize: () => {
        return setSelected(size);
      },
    };
  });

  return {
    sizes: formattedSizes,
    selectedSize:
      selected !== null
        ? selected
        : sizes?.length === 1
          ? sizes?.[0]
          : undefined,
  };
};

export default useSizes;

export const sizeContext = createContext<{
  selectedSize: ProductSize | null;
  setSelectedSize: (size: ProductSize | null) => void;
} | null>(null);

export const SizeProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectedSize, setSelectedSize] = useState<ProductSize | null>(null);
  return (
    <sizeContext.Provider
      value={{
        selectedSize,
        setSelectedSize,
      }}
    >
      {children}
    </sizeContext.Provider>
  );
};

export const useSizeContext = () => {
  return use(sizeContext);
};
